<template>
  <el-dialog
    class="dialog-padding"
    :visible.sync="isShow"
    width="776px"
    @close="onclose"
  >
    <div class="login-main flex-between">
      <div class="login-item">
        <div class="login-item-c">
          <h2 class="login-title">微信扫码快速登录</h2>
          <div class="login-code">
            <wxlogin
              :appid="appid"
              :scope="scope"
              href="https://100.canpoint.net/wxLogin.css"
              :redirect_uri="redirectUri"
            ></wxlogin>
          </div>
        </div>
        <div class="font-12 color-9  msg-box">
          注：如微信未绑定任何账号，绑定微信后扫码登录
        </div>
      </div>
      <div class="login-item">
        <h2 class="login-title">帐号密码登录</h2>
        <div class="login-form">
          <el-form ref="loginForm" :model="form" :rules="rules">
            <el-form-item prop="guid" class="input-item">
              <el-input
                placeholder="请输入帐号"
                prefix-icon="el-icon-user"
                v-model="form.guid"
              >
              </el-input>
            </el-form-item>

            <el-form-item prop="password" class="input-item">
              <el-input
                type="password"
                placeholder="请输密码"
                prefix-icon="el-icon-key"
                v-model="form.password"
              >
              </el-input>
            </el-form-item>
            <div class="font-12 login-msg" v-show="isError">
              请输入正确的帐号或密码
            </div>
            <el-button
              type="primary"
              class="login-button"
              @click="submitForm()"
              :loading="fullscreenLoading"
              >登录</el-button
            >
          </el-form>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { appid } from "../../config/env";
import store from "../../store/index";
import router from "../../router/index";
import wxlogin from "vue-wxlogin";
export default {
  components: {
    wxlogin,
  },
  data() {
    return {
      fullscreenLoading: false,
      isShow: false,
      form: {
        guid: "",
        password: "",
      },
      rules: {
        guid: [{ required: true, message: "请填写帐号", trigger: "blur" }],
        password: [{ required: true, message: "请填写密码", trigger: "blur" }],
      },
      isError: false,
      locationUrl: "",
      appid: appid,
      scope: "snsapi_login",
      redirectUri: "https://www.canpoint.net/login/third/wxlogin2",
    };
  },
  props: {},
  created() {},
  methods: {
    init() {
      console.log(router);
      this.isShow = true;
      store.commit("LOGIN_INSERT", true);
    },
    submitForm() {
      this.isError = false;
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.fullscreenLoading = true;
          this.postRequest("/wenjiaoopne/kc/auth/index", this.form)
            .then((result) => {
              this.fullscreenLoading = false;
              if (result.error_code > 0) {
                this.isError = true;
                return false;
              }
              this.isShow = false;
              store.commit("USER_SIGNIN", result.data.user);
              router.go(0);
              return false;
            })
            .catch(() => {
              this.fullscreenLoading = false;
            });
        } else {
          return false;
        }
      });
    },
    onclose() {
      store.commit("LOGIN_INSERT", false);
    },
  },
};
</script>
<style scoped>
.login-main {
  padding: 40px;
}
.login-main .login-item {
  position: relative;
  width: 341px;
  height: 370px;
}
.login-main .login-item-c {
  width: 302px;
  margin: 0 auto;
}
.login-main .login-form {
  width: 300px;
  margin: 0 auto;
}
.login-main .login-title {
  color: #333;
  text-align: center;
  margin-bottom: 30px;
}
.login-main .login-button {
  margin-top: 50px;
  width: 300px;
}
.login-main .input-item {
  margin: 30px 0;
}
.login-main .login-msg {
  color: #bc4654;
}
.login-main .login-code {
  width: 225px;
  height: 225px;
  border: 1px solid #e2e2e2;
  margin: 0 auto;
}
.msg-box {
  position: absolute;
  bottom: -25px;
  left: 0;
  width: 341px;
  text-align: center;
}
</style>
